import { render, staticRenderFns } from "./followIcon.vue?vue&type=template&id=6c19ef66&lang=pug"
import script from "./followIcon.vue?vue&type=script&lang=js"
export * from "./followIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports